import React from 'react';
import './FactsAndFigures.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faProjectDiagram, faBusinessTime, faEuroSign, faPercentage, faMoneyCheckAlt, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import CountUp from 'react-countup';

const FactsAndFigures = () => {
  return (
    <section className="facts-figures">
      <h2>Hechos y Cifras</h2>
      <div className="figures-container">
        <div className="figure-item">
          <FontAwesomeIcon icon={faProjectDiagram} className="icon" />
          <h3><CountUp end={150} duration={2} />+</h3>
          <p>Proyectos realizados</p>
        </div>
        <div className="figure-item">
          <FontAwesomeIcon icon={faBusinessTime} className="icon" />
          <h3><CountUp end={20} duration={2} /></h3>
          <p>Años de experiencia</p>
        </div>
        <div className="figure-item">
          <FontAwesomeIcon icon={faEuroSign} className="icon" />
          <h3><CountUp end={400000} duration={2} prefix="€" separator="," /></h3>
          <p>Capital mínimo</p>
        </div>
        <div className="figure-item">
          <FontAwesomeIcon icon={faPercentage} className="icon" />
          <h3><CountUp end={15} duration={2} />% - <CountUp end={17} duration={2} />%</h3>
          <p>Tasa Interna de Retorno (TIR)</p>
        </div>
        <div className="figure-item">
          <FontAwesomeIcon icon={faMoneyCheckAlt} className="icon" />
          <h3>Al cierre de cada operación</h3>
          <p>Pago de dividendos</p>
        </div>
        <div className="figure-item">
          <FontAwesomeIcon icon={faCalendarAlt} className="icon" />
          <h3><CountUp end={4} duration={2} /> - <CountUp end={24} duration={2} /> meses</h3>
          <p>Plazo de inversión</p>
        </div>
      </div>
    </section>
  );
};

export default FactsAndFigures;
